import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import {
  PasswordResetForm,
  CodeConfirmForm,
} from 'app/components/PasswordReset';

import { useAppSelector } from 'app/store';
import { getPasswordResetLinkSelector } from 'app/store/Auth/selectors';
import { routes } from 'app/routing/routesConfig';
import { useFetchValidationSchema } from 'app/utils/hooks';
import { ChakraAppLoader } from 'app/components/Core';

type PasswordResetSteps = 'email-prompt' | 'confirm-code';

interface CodeConfirmData {
  confirmLink: string;
  email: string;
}

export const PasswordReset = () => {
  const [step, setStep] = useState<PasswordResetSteps>('email-prompt');
  const [confirmData, setConfirmData] = useState<CodeConfirmData>();
  const navigate = useNavigate();

  const passwordResetLink = useAppSelector(getPasswordResetLinkSelector);
  const { validationSchema } = useFetchValidationSchema({
    link: passwordResetLink,
  });

  if (!passwordResetLink) {
    return <Navigate to={routes.auth.path} />;
  }

  switch (step) {
    case 'confirm-code': {
      if (!confirmData) return <ChakraAppLoader />;

      return (
        <CodeConfirmForm
          onConfirm={() => {
            setConfirmData(undefined);
            navigate(routes.auth.path);
          }}
          confirmLink={confirmData.confirmLink}
          email={confirmData.email}
          resetLink={passwordResetLink.href}
        />
      );
    }
    case 'email-prompt': {
      if (!validationSchema) return <ChakraAppLoader />;

      return (
        <PasswordResetForm
          onReset={(confirmLink, email) => {
            setConfirmData({ confirmLink, email });
            setStep('confirm-code');
          }}
          passwordResetLink={passwordResetLink.href}
          emailValidation={validationSchema}
        />
      );
    }

    default:
      return null;
  }
};
